export const errorBoundary = {
  Oops: "Oops",
  ApplicationErrorText: "Looks like we ran into an error.",
  ApplicationErrorMessage:
    "Please reload the page and try again. We've been notified of the issue and will work to resolve it.",
  BackToHome: "Back to home",
  NotFoundTitle: "This page doesn't exist",
  NotFoundMessage:
    "The web address may be incorrect or the page may have been moved. If you're not sure, simply go to the homepage and find what you are looking for from there.",
  GoHome: "Go home",
  NotFoundSupportText: "Having trouble? Ask for help by visiting",
} as const;
